import { Cartesian3, Color } from "cesium";

class TransformAxis {
  static readonly X: string = "X";
  static readonly Y: string = "Y";
  static readonly Z: string = "Z";

  static getValue(axis: string): Cartesian3 {
    if (axis === TransformAxis.X) {
      return Cartesian3.UNIT_X;
    } else if (axis === TransformAxis.Y) {
      return Cartesian3.UNIT_Y;
    }
    return Cartesian3.UNIT_Z;
  }

  static getColor(axis: string): Color {
    if (axis === TransformAxis.X) {
      return Color.RED;
    } else if (axis === TransformAxis.Y) {
      return Color.GREEN;
    }
    return Color.BLUE;
  }
}

export default Object.freeze(TransformAxis);
